import { render, staticRenderFns } from "./AgentFeaturePromotionDialog.vue?vue&type=template&id=f4039990&scoped=true"
import script from "./AgentFeaturePromotionDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./AgentFeaturePromotionDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AgentFeaturePromotionDialog.vue?vue&type=style&index=0&id=f4039990&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4039990",
  null
  
)

export default component.exports